export const createTemplate = (referenceNumber, date, data, futureDate) => {
  return `
 <div>
 <p class="mb-2"><strong>${referenceNumber}</strong></p>
 <p class="mb-2">${date}</p>
 <p></p>
 <p class="mb-0">The Harbor Master, Sri Lanka Ports Authority,</p>
 <p class="mb-0">The Director Security, Control Room (security),</p>
 <p class="mb-0">CAPO, Operation Branch, Sri Lanka Custom,</p>
 <p class="mb-0">CAPO, Gate, Sri Lanka Customs, Colombo,</p>
 <p class="mb-0">The Manager Operations, JCT Terminals.</p>
 <p></p>
 <p><span style="text-transform: uppercase;margin-bottom: 1.1rem;"><strong><u>RE:Removal of  
    ${data.job.lines.map(line => `${line.service_type} `).join('')} from 
    <span>${data.job.vessel_name}</span>
    <span> on ${data.job.vessel_arrival_date}</span></u></strong>
    </span>
 </p>
 <p></p>
 <p>We are pleased to inform you that, the agent/master of the above marine vessel has appointed us to remove the 
 ${data.job.lines.map(line => `<strong>${line.service_type} - ${Math.round(line.estimated_volume)} ${line.unit_of_measurement}</strong> `).join('')}
 By Using truck accordingly,
 </p>
 <p></p>
 <p>
  We shall be thankful if you kindly grant permission to enter the Colombo Port for the following vehicles and the personnel to remove
  ${data.job.lines.map(line => `<strong>${line.service_type}</strong> `).join('')}
  <strong> on ${data.job.vessel_arrival_date}</strong> to <strong>${futureDate}</strong>
 </p>
 <p></p>
 <p>Shipping agent's/master's request letter is attached herewith.</p>
 <p></p>
 <div data-type="two-column-wrapper" style="display:flex; gap:32px;">
  <p><strong>Name</strong></p>
  <p><strong>NIC No.</strong></p>
 </div>
  <div data-type="two-column-wrapper" style="display:flex; gap:32px;">
    <div data-type="two-column" style="display:flex; flex-direction:column; gap:2px;">
      <p>1. B.K.A.T. Perera – 693452732V</p>
      <p>2. B.K.A.U. Perera – 751292287V</p>
      <p>3. R.A. Amitha – 641830291V</p>
      <p>4. B.M. Thilakarathna – 821483212V</p>
      <p>5. S.A.D.M. Satharasinghe – 933560414V</p>
      <p>6. D.M.A. Sampath – 873531436V</p>
      <p>7. D.M. Gunarathna – 583153551V</p>
    </div>

    <div data-type="two-column" style="display:flex; flex-direction:column; gap:2px;">
      <p>8. R.A.J. Sriyantha – 811493694V</p>
      <p>9. W.A.A.P. Weerasinghe – 783574527V</p>
      <p>10. M.S. Mohamed – 198314904379</p>
      <p>11. K.P. Samaraweera – 792152198V Dri</p>
      <p>12. W. Adishtaraja – 850017301</p>
      <p>13. A.L.G. Dammika – 197301000329 Dri</p>
      <p>14. B.M.S.M. Basnayaka – 963182040V Dri</p>
    </div>
  </div>
  <p></p>
  <p><strong>Vehicle No: LK-0417 / LH-7537 / PH-8666 / BFU-6197 / JM-8518 / HQ-7508 / LH-7043 </strong></p>
  <p></p>
  <p></p>
 </div>
 `
}

export default {
  createTemplate
}
